var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7531_6168)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7531_6168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5467 35.5464H26.4534C24.1706 35.5464 22.3201 37.3969 22.3201 39.6797V126.48C22.3201 128.763 24.1706 130.613 26.4534 130.613H97.5467C99.8295 130.613 101.68 128.763 101.68 126.48V39.6797C101.68 37.3969 99.8295 35.5464 97.5467 35.5464Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.56 43.813H33.0667C31.697 43.813 30.5867 44.9233 30.5867 46.293C30.5867 47.6627 31.697 48.773 33.0667 48.773H54.56C55.9297 48.773 57.04 47.6627 57.04 46.293C57.04 44.9233 55.9297 43.813 54.56 43.813Z",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.56 78.5332H33.0667C31.697 78.5332 30.5867 79.6435 30.5867 81.0132C30.5867 82.3829 31.697 83.4932 33.0667 83.4932H54.56C55.9297 83.4932 57.04 82.3829 57.04 81.0132C57.04 79.6435 55.9297 78.5332 54.56 78.5332Z",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2797 56.2134H34.7197C32.8935 56.2134 31.413 57.6938 31.413 59.52V67.7867C31.413 69.6129 32.8935 71.0934 34.7197 71.0934H89.2797C91.1059 71.0934 92.5864 69.6129 92.5864 67.7867V59.52C92.5864 57.6938 91.1059 56.2134 89.2797 56.2134Z",
    stroke: "#F5A342",
    strokeWidth: 1.97333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28 90.1064H34.72C32.4372 90.1064 30.5867 91.957 30.5867 94.2398V100.853C30.5867 103.136 32.4372 104.986 34.72 104.986H89.28C91.5628 104.986 93.4133 103.136 93.4133 100.853V94.2398C93.4133 91.957 91.5628 90.1064 89.28 90.1064Z",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0934 72.7462C73.3762 72.7462 75.2268 70.8956 75.2268 68.6128C75.2268 66.33 73.3762 64.4795 71.0934 64.4795C68.8106 64.4795 66.9601 66.33 66.9601 68.6128C66.9601 70.8956 68.8106 72.7462 71.0934 72.7462Z",
    fill: "#FBE0C0",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3232 86.2786C73.6619 86.2786 73.0444 86.2786 72.4822 86.2431C71.7898 86.1962 71.1237 85.9593 70.5573 85.5584C69.9908 85.1574 69.5459 84.608 69.2715 83.9706L65.7837 77.0778C65.5279 76.78 65.4002 76.3931 65.4284 76.0015C65.4566 75.6099 65.6384 75.2453 65.9342 74.9872C66.1766 74.7924 66.4789 74.6875 66.7898 74.6904C67.0187 74.6971 67.2434 74.7533 67.4485 74.8552C67.6536 74.9571 67.8342 75.1022 67.9777 75.2806L69.5616 77.4424L69.5856 77.4705V69.2576C69.5856 68.8501 69.7475 68.4593 70.0356 68.1712C70.3237 67.8831 70.7145 67.7212 71.122 67.7212C71.5294 67.7212 71.9202 67.8831 72.2083 68.1712C72.4964 68.4593 72.6583 68.8501 72.6583 69.2576V74.6309C72.6405 74.4332 72.664 74.2339 72.7274 74.0458C72.7909 73.8576 72.8928 73.6848 73.0267 73.5382C73.1606 73.3917 73.3236 73.2746 73.5053 73.1945C73.687 73.1145 73.8833 73.0731 74.0818 73.0731C74.2804 73.0731 74.4767 73.1145 74.6584 73.1945C74.84 73.2746 75.003 73.3917 75.137 73.5382C75.2709 73.6848 75.3728 73.8576 75.4362 74.0458C75.4997 74.2339 75.5232 74.4332 75.5054 74.6309V75.751C75.4875 75.5533 75.5111 75.354 75.5745 75.1659C75.6379 74.9778 75.7398 74.8049 75.8738 74.6584C76.0077 74.5118 76.1707 74.3948 76.3523 74.3147C76.534 74.2346 76.7303 74.1932 76.9289 74.1932C77.1274 74.1932 77.3238 74.2346 77.5054 74.3147C77.6871 74.3948 77.8501 74.5118 77.984 74.6584C78.1179 74.8049 78.2198 74.9778 78.2833 75.1659C78.3467 75.354 78.3702 75.5533 78.3524 75.751V76.6141C78.3345 76.4163 78.3581 76.2171 78.4215 76.0289C78.4849 75.8408 78.5869 75.668 78.7208 75.5214C78.8547 75.3748 79.0177 75.2578 79.1994 75.1777C79.381 75.0976 79.5774 75.0563 79.7759 75.0563C79.9744 75.0563 80.1708 75.0976 80.3525 75.1777C80.5341 75.2578 80.6971 75.3748 80.831 75.5214C80.965 75.668 81.0669 75.8408 81.1303 76.0289C81.1937 76.2171 81.2173 76.4163 81.1994 76.6141V81.8526C81.1713 83.4638 80.443 86.1802 77.8812 86.1802C77.6952 86.1885 76.1196 86.2794 74.3265 86.2794L74.3232 86.2786Z",
    fill: "#A6ADB6",
    stroke: "white",
    strokeWidth: 0.986667
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7531_6168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 99.5845,
    cy: 70.3807,
    rx: 15.1556,
    ry: 15.5,
    transform: "rotate(-176.081 99.5845 70.3807)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 61.2291L100.89 74.1175L97.8118 73.9067L98.263 60.9681L102.073 61.2291ZM97.0218 77.5504C97.0604 76.9869 97.272 76.5279 97.6565 76.1734C98.0517 75.8093 98.5731 75.6495 99.2205 75.6938C99.858 75.7375 100.348 75.9666 100.69 76.3812C101.032 76.7855 101.184 77.2694 101.145 77.8329C101.108 78.3759 100.892 78.8294 100.497 79.1935C100.102 79.5473 99.5863 79.7024 98.9489 79.6587C98.3014 79.6143 97.8064 79.39 97.4638 78.9857C97.1319 78.5718 96.9846 78.0934 97.0218 77.5504Z",
    fill: "#B4BDC6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7531_6168",
    x: 8.22483,
    y: 26.7369,
    width: 100.503,
    height: 116.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.52381,
    dy: 1.7619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7531_6168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7531_6168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7531_6168",
    x: 84.4267,
    y: 54.8818,
    width: 38.2442,
    height: 43.3314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.40476,
    dy: 8.80952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7531_6168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7531_6168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7531_6168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.1590f098aa0896f3a4499050b4f38cd6.svg";
export { ForwardRef as ReactComponent };